/*
 * Allows you to toggle the Expert Neutral Deal-Closer via a checkbox and autosaves
 *
 * Expects params: { party: (json obj) }
 */
import React from 'react';
import EndModal from './end_modal.js.jsx';
export default class ExpertNeutralToggleNJ extends React.Component {
  constructor(props) {
    super(props);
    this.state =  {
      expert_neutral_dealcloser: false,
      expert_neutral_terms: false
    };
  }

  componentDidMount() {
    this.loadEndPreference();
  }

  loadEndPreference() {
    $.ajax({
      url: '/api/v1/negotiations/' + this.props.negotiation_id + '/expert_neutral_dealcloser_preference',
      dataType: 'json',
      type: "GET",
      success: function(data) {
        this.setState({ expert_neutral_dealcloser: data.expert_neutral_dealcloser });
        this.setState({ expert_neutral_terms: data.expert_neutral_dealcloser });
      }.bind(this)
    });
    $.ajax({
      url: "/api/v1/negotiations/" + this.props.negotiation_id + "/get_end_agreement",
        dataType: 'json',
        success: function(data) {
          this.setState({expert_neutral_terms: data.accepted});
        }.bind(this),
      error: function(xhr, status, err) {
        console.error("/api/v1/negotiations/" + this.props.negotiation_id + "/get_end_agreement", status, err.toString());
      }.bind(this)
    });

  }

  updateEndPreference() {
    var scope = this;

    var post_data = {
      expert_neutral_dealcloser: this.state.expert_neutral_dealcloser
    };

		$.ajax({
      url: '/api/v1/negotiations/' + this.props.negotiation_id + '/update_expert_neutral_dealcloser_preference',
      dataType: 'json',
      type: "PUT",
      data: post_data,
      success: function(data) {
        this.setState({ expert_neutral_dealcloser: data.expert_neutral_dealcloser });

        $.notify({
          icon: 'fa fa-check',
          title: I18n.components.expert_neutral_toggle.edc_updated,
          message: ''
        },{ type: "success", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });

      }.bind(this),
      error: function(xhr, status, err) {

        $.notify({
          icon: 'fa fa-times',
          title: '',
          message: xhr.responseJSON || 'Failed to perfom action'
        },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });
      }.bind(this)
    });
  }
  handleTermsChange(obj, event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    obj[name] = value;
    if (value == false && this.state.expert_neutral_dealcloser == true){
      this.state.expert_neutral_dealcloser = false;
      
      //this.setState(this.state);
      this.setState(this.state, () => {this.updateEndPreference();});
    }
    this.setState(this.state);
  }

  handleInputChange(obj, event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    event.preventDefault();
    $.ajax({
      url: "/api/v1/negotiations/" + this.props.negotiation_id + "/get_end_agreement",
        dataType: 'json',
        success: function(data) {
          this.setState({expert_neutral_dealcloser: data.accepted}, () => {
            if (this.state.expert_neutral_terms == true){
              this.updateEndPreference();
              //this.setState(this.state, () => {this.updateEndPreference();});
              if (value == true){
                obj[name] = value;
                this.setState({expert_neutral_dealcloser: value}, () => {this.updateEndPreference();});
              }
            } else {
              this.setState({expert_neutral_dealcloser: null});
              $.notify({
                icon: 'fa fa-times',
                title: '',
                message: I18n.components.expert_neutral_toggle.expert_terms_required
              },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });
            }
          });
        }.bind(this),
      error: function(xhr, status, err) {
        console.error("/api/v1/negotiations/" + this.props.negotiation_id + "/get_end_agreement", status, err.toString());
      }.bind(this)
    });
  }
  handleInputNoChange(obj, event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if(value == true){
      obj[name] = !value;
      this.setState({expert_neutral_dealcloser: !value}, () => {this.updateEndPreference();});
    }
  }

  handleSign(isTrue){
    if ((!isTrue) && (this.state.expert_neutral_dealcloser == true)){
      this.setState({expert_neutral_dealcloser: null});
    }
    this.setState({expert_neutral_terms: isTrue});
  }
  toggleEndModal(){
    this.setState({expert_neutral_terms: true});
  }
  toggleNoEndModal(){
    this.setState({expert_neutral_terms: false});
  }
  termsClick(){
  }
  render() {
    var scope = this;

    return (
      <div>
        <input className="no-margin-top" type="checkbox" checked={this.state.expert_neutral_dealcloser} value={this.state.expert_neutral_dealcloser} name="expert_neutral_dealcloser" onChange={this.handleInputChange.bind(scope, scope.state)} />&nbsp;{I18n.components.expert_neutral_toggle.yes_check}
        <input className="no-margin-top margin-left-5" type="checkbox" checked={this.state.expert_neutral_dealcloser == false} value={this.state.expert_neutral_dealcloser == false} name="expert_neutral_dealcloser" onChange={this.handleInputNoChange.bind(scope, scope.state)}  />&nbsp; {I18n.components.expert_neutral_toggle.no_check}
        <EndModal expert_neutral_terms={this.state.expert_neutral_terms} termsCallback={this.handleSign} text={I18n.components.expert_neutral_toggle.use_edc2} negotiation_id={this.props.negotiation_id} content="Des" ref={this.endModal} handleClose={this.toggleEndModal} handleNoClose={this.toggleNoEndModal} />
        <br />
      </div>
    );
  }
}
